import MapComponent from './map';

export default MapComponent;
